<script setup>
import { computed } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import { inject } from "vue";

const route = inject("route");

const props = defineProps({
  page: { type: String, default: "" },
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
  current: { type: String, default: "" },
  image: { type: String, default: "" },
  color: { type: String, default: "#7a2f2f" },
});

const inertiaPage = usePage();

const cfg = computed(() => {
  const all = inertiaPage.props?.pageHeroes || {};
  return (props.page && all[props.page]) || {};
});

const heroTitle = computed(() => cfg.value.title || props.title);
const heroSubtitle = computed(() =>
  cfg.value.subtitle != null && cfg.value.subtitle !== ""
    ? cfg.value.subtitle
    : props.subtitle
);
const heroCurrent = computed(() => props.current || heroTitle.value);
const heroColor = computed(() => cfg.value.color || props.color || "#7a2f2f");

const heroImage = computed(() => {
  const img = cfg.value.image || props.image;
  if (!img) return "/storage/images/BGUNG.png";
  if (/^https?:\/\//.test(img) || img.startsWith("/storage")) return img;
  return "/storage/" + img;
});

const overlayStyle = computed(() => ({
  backgroundImage: `linear-gradient(to right, ${heroColor.value}f2, ${heroColor.value}d9, ${heroColor.value}8c)`,
}));
</script>

<template>
  <section class="relative overflow-hidden">
    <div class="absolute inset-0">
      <img :src="heroImage" alt="" class="object-cover w-full h-full" />
      <div class="absolute inset-0" :style="overlayStyle"></div>
    </div>

    <div class="relative max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 py-16 sm:py-24">
      <nav class="flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-white/70">
        <Link :href="route('home')" class="transition-colors hover:text-white">Beranda</Link>
        <span class="text-white/40">/</span>
        <span class="text-white">{{ heroCurrent }}</span>
      </nav>

      <h1 class="mt-4 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl font-playfair">
        {{ heroTitle }}
      </h1>

      <p v-if="heroSubtitle" class="max-w-2xl mt-4 text-sm leading-relaxed sm:text-base text-white/90">
        {{ heroSubtitle }}
      </p>
    </div>
  </section>
</template>
